module.exports = __webpack_public_path__ + "static/media/ageelementantiwrinkleconcentrate.ce61446f.png";